import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class ExtensionRegisterSessionStorageService {
   private readonly extensionOrderingOptionsStorageKey = '__ndt-extension-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removeExtensionOrderingOptions(): void {
      localStorage.removeItem(this.extensionOrderingOptionsStorageKey);
   }

   getExtensionOrderingOptions() {
      const localData = localStorage.getItem(this.extensionOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setExtensionOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.extensionOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
